import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpParams } from '@angular/common/http';
import { Client } from '../../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { LocalStorageService } from '../../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ChangeCurrentClientDialogInput } from './change-current-client-dialog';

@Component({
    selector: 'kiene-change-current-client-dialog',
    templateUrl: './change-current-client-dialog.component.html',
    styleUrls: ['./change-current-client-dialog.component.scss'],
})
export class ChangeCurrentClientDialogComponent implements OnInit {
    params: HttpParams;
    currentClient: Client;
    isAdmin = false;
    showInactiveToggle = false;
    inaktive = false;

    constructor(
        public dialogRef: MatDialogRef<ChangeCurrentClientDialogComponent>,
        private localStorageService: LocalStorageService,
        @Inject(MAT_DIALOG_DATA) private input: ChangeCurrentClientDialogInput,
    ) {
        this.currentClient = this.input?.client;
        this.isAdmin = localStorageService.currentUserIsAdmin();
        this.showInactiveToggle = this.isAdmin || !!localStorageService.getCurrentUser()?.menue?.labor;
        if (localStorageService.isCurrentUserPhitoUser()) {
            this.inaktive = true;
        }
    }

    setParams(inaktiv: boolean) {
        let par = new HttpParams().set('limit', '25');
        if (inaktiv) {
            par = par.set('inaktiv', '1');
        } else {
            par = par.set('aktiv', 1);
        }

        if (this.input?.nurSchweinebetriebe === true) {
            par = par.set('schwein', 1);
        }
        if (this.input?.nurRinderbetriebe === true) {
            par = par.set('rind', 1);
        }
        this.params = par;
    }

    ngOnInit() {
        this.setParams(this.inaktive);
    }

    setCurrentClient(client: Client) {
        const result = { save: true, client: client };
        this.dialogRef.close(result);
    }

    getDisplayFields(): string[] {
        let df = [
            'vvvo',
            'bezeichnung_final',
            'zusatz_final',
            'kunde_nr_intern',
            'ort_final',
            'strasse_final',
            'unternehmensgruppe',
        ];
        if (this.localStorageService.isCurrentUserPhitoUser()) {
            df.push('kunde_id');
            df.push('betrieb_id');
        }
        return df;
    }

    inaktiveAnzeigen(event: MatCheckboxChange) {
        this.setParams(event.checked);
    }
}
